import React from "react";

const Bash_Home = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Home</h2>
      <p>Welcome to the Bash tutorial collection. Each component in this bundle explains a specific Bash command, concept, or scripting topic with examples.</p><p>Use these components as ready-made pages for a tutorial site.</p>
    </div>
  );
};

export default Bash_Home;
